<div nz-row [nzGutter]="[48, 24]">
  <div nz-col nzSpan="24">
    <h5 class="divider-title"><i nz-icon [nzType]="icon" nzTheme="outline"></i>&nbsp;{{ title }}</h5>
  </div>
</div>
